(() => {
  'use strict';
  const dialog = document.querySelector('[data-rewards-popup]');
  if (!dialog || typeof dialog.showModal !== 'function' || dialog.dataset.initialized) return;
  dialog.dataset.initialized = 'true';
  const storageKey = 'ouson-rewards-popup-v1-dismissed';
  const sevenDays = 7 * 24 * 60 * 60 * 1000;
  let pageDismissed = false;
  let timer;
  const suppressed = () => {
    if (pageDismissed) return true;
    try {
      const value = Number(localStorage.getItem(storageKey));
      return value > 0 && Date.now() - value < sevenDays;
    } catch { return false; }
  };
  const remember = () => {
    pageDismissed = true;
    try { localStorage.setItem(storageKey, String(Date.now())); } catch { /* The current page remains dismissible without storage. */ }
  };
  const close = () => { remember(); dialog.close(); };
  dialog.querySelector('[data-rewards-close]').addEventListener('click', close);
  dialog.querySelector('[data-rewards-login]').addEventListener('click', remember);
  dialog.addEventListener('cancel', remember);
  dialog.addEventListener('close', () => {
    document.documentElement.classList.remove('ouson-rewards-popup-open');
  });
  dialog.addEventListener('click', (event) => {
    if (event.target !== dialog) return;
    const rect = dialog.getBoundingClientRect();
    if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) close();
  });
  const blocked = () => document.visibilityState !== 'visible' ||
    [...document.querySelectorAll('dialog[open], [aria-modal="true"]')].some((item) => item !== dialog && item.getBoundingClientRect().width > 0) ||
    ['INPUT', 'TEXTAREA', 'SELECT'].includes(document.activeElement?.tagName);
  const image = dialog.querySelector('[data-rewards-image]');
  const show = (attempt = 0) => {
    if (!dialog.isConnected || dialog.open || suppressed()) return;
    if (blocked()) {
      if (attempt < 15) timer = setTimeout(() => show(attempt + 1), 2000);
      return;
    }
    if (!image.complete || !image.naturalWidth) return;
    dialog.showModal();
    document.documentElement.classList.add('ouson-rewards-popup-open');
  };
  const prepare = () => {
    if (suppressed() || !dialog.isConnected) return;
    image.addEventListener('load', () => show(), { once: true });
    image.src = image.dataset.src;
  };
  if (dialog.dataset.designMode === 'true') return;
  if (!suppressed()) prepare();
  window.addEventListener('pagehide', () => {
    clearTimeout(timer);
    if (dialog.open) dialog.close();
  });
})();



